module.exports = __webpack_public_path__ + "img/api-product.ed05e256.svg";